export default __webpack_public_path__ + "static/material_plastic-2cfa5b986e957cea80f9bfa98242155c.png";